var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-w360 q-fit"},[_c('question-with-error-wrap',{attrs:{"error":_vm.getFieldsError(['skinType'])}},[_c('single-answer-question',{attrs:{"title":"label.mySkinType","value":_vm.skinType,"options":_vm.skinTypeOptions},on:{"input":function($event){return _vm.onFieldChange('skinType', $event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }